export const boardDelegationRoles = {
  PARTNER: 'PARTNER',
  PARTNER_REPRESENTANT: 'PARTNER_REPRESENTANT',
};
